// Release control for certification tracks (QA CP-003).
//
// A track listed here is hidden from every place a NEW quiz can start (track selector,
// quiz config, /try sample quiz, pricing). Historical results are untouched, so the
// dashboard keeps rendering past attempts.
//
// Defaults to AWS being unavailable until the rebuilt SAA-C03 bank passes the retest
// checklist. To re-enable, build with VITE_DISABLED_CERTS=none (or a comma list such as
// "aws"). The API enforces the same list (DISABLED_CERTIFICATIONS) so a stale or
// hand-edited client cannot reach the corrupted bank either.

export type CertificationId = 'comptia' | 'aws';

const ALL_CERTS: CertificationId[] = ['comptia', 'aws'];

export function parseDisabledCerts(raw: string | undefined | null): CertificationId[] {
    if (raw == null || raw.trim() === '') return ['aws'];
    const parts = raw
        .split(',')
        .map((part) => part.trim().toLowerCase())
        .filter(Boolean);
    if (parts.includes('none')) return [];
    return ALL_CERTS.filter((id) => parts.includes(id));
}

const env = (typeof import.meta !== 'undefined' ? import.meta.env : undefined) as
    | Record<string, string | undefined>
    | undefined;

export const DISABLED_CERTS: CertificationId[] = parseDisabledCerts(env?.VITE_DISABLED_CERTS);

export function isCertEnabled(id: string | null | undefined): boolean {
    return !!id && !(DISABLED_CERTS as string[]).includes(id);
}

/** First enabled track, used as the fallback when a disabled one is requested. */
export const DEFAULT_CERT: CertificationId = ALL_CERTS.find(isCertEnabled) ?? 'comptia';
